import { apiFetch } from '@/lib/api';
import type { UiTranslationPack } from '@/types/translation';

export async function getPack(lang: string): Promise<UiTranslationPack> {
  return apiFetch<UiTranslationPack>(`/ui-translations?lang=${encodeURIComponent(lang)}`);
}

export async function upsertKey(lang: string, key: string, value: string): Promise<void> {
  await apiFetch(`/ui-translations-admin/${encodeURIComponent(lang)}/${encodeURIComponent(key)}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  });
}

export async function deleteKey(lang: string, key: string): Promise<void> {
  await apiFetch(`/ui-translations-admin/${encodeURIComponent(lang)}/${encodeURIComponent(key)}`, {
    method: 'DELETE',
  });
}

export async function bulkUpsert(
  lang: string,
  items: Array<{ key: string; value: string }>,
): Promise<{ inserted_or_updated: number }> {
  return apiFetch<{ inserted_or_updated: number }>(
    `/ui-translations-admin/${encodeURIComponent(lang)}/bulk`,
    { method: 'POST', body: JSON.stringify({ items }) },
  );
}
